import { useMutation, useQueryClient } from "@tanstack/react-query";

import { addToolAllowlistItem } from "./api";
import type { AddToolAllowlistItemRequest, ToolAllowlistItem } from "./api";

// POST одного разрешения. На успех инвалидируем список пары (org, role) —
// новое разрешение появится в таблице без ручного refetch'а. Ключ
// включает role_name (тот же ключ, что у useToolAllowlist).
export function useAddToolAllowlistItem(): ReturnType<
  typeof useMutation<ToolAllowlistItem, Error, AddToolAllowlistItemRequest>
> {
  const queryClient = useQueryClient();
  return useMutation<ToolAllowlistItem, Error, AddToolAllowlistItemRequest>({
    mutationFn: (body) => addToolAllowlistItem(body),
    onSuccess: (_item, variables) => {
      void queryClient.invalidateQueries({
        queryKey: ["toolAllowlist", variables.role_name],
      });
    },
  });
}
